<div class="modal-header mfp-header">
    <h5 class="modal-title">{{ Employee.EmployeeID ? 'Edit' : 'Create' }} Employee</h5>
    <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="Cancel()"
    ></button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="row my-2">
            <div class="col-12 col-md-6">Employee ID:</div>
            <div class="col-12 col-md-6">
                <input type="number" class="form-control" [(ngModel)]="Employee.PaycorID" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">First Name:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="Employee.FirstName" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Last Name:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="Employee.LastName" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Phone Number:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="Employee.PhoneNumber" />
            </div>
        </div>
        <div class="row my-2" *ngFor="let department of Employee.Departments; index as i; first as isFirst">
            <div class="col-12 col-md-6"><span *ngIf="isFirst">Departments:</span></div>
            <div class="col-12 col-md-6">
                <div class="input-group">
                    <input type="text" class="form-control" [ngModel]="department.Name" disabled />
                    <button type="button"
                            class="btn btn-danger"
                            (click)="DeleteDepartment(i)">
                        Delete
                    </button>
                </div>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6"><span *ngIf="!Employee.Departments.length">Departments:</span></div>
            <div class="col-12 col-md-6">
                <div class="input-group">
                    <select class="form-select" [(ngModel)]="NewDepartment" [compareWith]="CompareDepartments">
                        <option *ngFor="let department of AvailableDepartments" [ngValue]="department">
                            {{ department.Name }}
                        </option>
                    </select>
                    <button type="button"
                            class="btn btn-success"
                            (click)="AddDepartment()">
                        Add
                    </button>
                </div>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Start Date:</div>
            <div class="col-12 col-md-6">
                <input type="date"
                       class="form-control"
                       [ngModel]="Employee.StartDate | date:'yyyy-MM-dd'"
                       (ngModelChange)="Employee.StartDate = $event" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Last Day:</div>
            <div class="col-12 col-md-6">
                <input type="date"
                       class="form-control"
                       [ngModel]="Employee.EndDate | date:'yyyy-MM-dd'"
                       (ngModelChange)="Employee.EndDate = $event" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Birthday:</div>
            <div class="col-12 col-md-6">
                <input type="date"
                       class="form-control"
                       [ngModel]="Employee.BirthDate | date:'yyyy-MM-dd'"
                       (ngModelChange)="Employee.BirthDate = $event" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">&nbsp;</div>
            <div class="col-12 col-md-6">
                <label>
                    <input type="checkbox" [(ngModel)]="Employee.IsActive" />
                    Is Active
                </label>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="Cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="Save()">Save</button>
</div>